import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'comma',
  standalone: false,
})
export class CommaPipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      value = value.trim();
      if (value) {
        return value + ',';
      }
    }
  }
}
